<template>
  <div class="header">
    <div class="headerLeft">
      <div class="logo mrl">
        <img class="logo_img" src="../../assets/logo.png" alt="" />
      </div>
    </div>
    <div class="headerRight mrl">
      <SearchBar></SearchBar>
      <Language></Language>
      <Profil></Profil>
    </div>
  </div>
</template>

<script>
import SearchBar from "./Search";
import Profil from "./Profil";
import Language from "./Language";
export default {
  name: "Header",
  components: {
    SearchBar,
    Profil,
    Language,
  },
  methods: {
    focusClear() {
      this.isFocus = false;
      this.search = "";
    },
    inputFocus() {
      this.isFocus = true;
    },
  },
};
</script>

<style lang="scss">
.header {
  background: rgba(74, 144, 226, 0.2);
  box-shadow: 0px 2px 6px 0px rgba(23, 65, 113, 0.2);
  height: 60px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.mrl {
  margin: 0px 20px;
}
.avatar {
  margin-bottom: 6px;
}
.headerRight {
  display: flex;
}
.logo_img {
  width: 151px;
  height: 40px;
}
.search__container-icon {
  font-size: 20px !important;
  margin-top: 4px;
}
.lang {
  margin: 0px 20px;
  width: 23px !important;
  height: 24px !important;
  &.dp-select--primary .dp-select--selection {
    background: transparent !important;
    border-color: transparent !important;
    color: #174171;
  }
  .dp-select__controller {
    font-weight: 600 !important;
    font-size: 15px;
  }
  #reference > div > div.dp-select__indicators > i {
    display: none;
  }
  #reference > div {
    width: 35px;
    height: 40px;
  }
}
</style>
